import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconArrowDown = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0002 7.33325C13.0002 6.78097 12.5525 6.33325 12.0002 6.33325C11.448 6.33325 11.0002 6.78097 11.0002 7.33325V14.2524L8.04068 11.2928C7.65015 10.9023 7.01699 10.9023 6.62646 11.2928C6.23594 11.6833 6.23594 12.3165 6.62646 12.707L11.2931 17.3737C11.6837 17.7642 12.3168 17.7642 12.7073 17.3737L17.374 12.707C17.7645 12.3165 17.7645 11.6833 17.374 11.2928C16.9835 10.9023 16.3503 10.9023 15.9598 11.2928L13.0002 14.2524V7.33325Z"
        />
      </svg>
    );
  }
);
